// import { IonIcon } from '@ionic/react';
import '@ionic/react/css/ionic-swiper.css';
// import { arrowForwardOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// swiper bundle styles
import 'swiper/swiper-bundle.min.css';
// swiper core styles
import 'swiper/swiper.min.css';
import DAService from '../../services/DAService.service';
import ProcessGoalCard from '../Cards/ProcessGoalCard';
import './PopularProcessGoals.scss';

// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

export default function PopularProcessGoals(props: {
  screenSize: number;
}) {
  const { screenSize } = props;
  const [slidesPerView, setSlidesPerView] = useState<number>(1);
  const [goals, setGoals] = useState<any[]>([]);

  useEffect(() => {
    // handle slidesPerView
    if (screenSize < 500) {
      setSlidesPerView(1.5);
    } else if (screenSize < 550) {
      setSlidesPerView(2.1);
    } else if (screenSize < 600) {
      setSlidesPerView(2.2);
    } else if (screenSize < 700) {
      setSlidesPerView(2.3);
    } else if (screenSize < 800) {
      setSlidesPerView(2.5);
    } else if (screenSize < 1400) {
      setSlidesPerView(3.2);
    } else {
      setSlidesPerView(5);
    }
  }, [screenSize]);

  useEffect(() => {
    setGoals(DAService.getPlaylist('goals'));
  }, []);

  return (
    <>
      <div className="section-label" data-testid="popular-process-goals">
        Popular Process Goals
      </div>
      <Swiper
        slidesPerView={slidesPerView}
        loop
        observeParents
        observer
        navigation={{
          nextEl: '.next',
        }}
      >
        {
          goals.map((goal) => (
            <SwiperSlide key={`slider-${goal.itemId}`}>
              <Link
                style={{ textDecoration: 'none' }}
                to={`/goals/${goal.itemId}`}
                type="button"
                key={`button-${goal.itemId}`}
              >
                <ProcessGoalCard goal={goal} />
              </Link>
            </SwiperSlide>
          ))
        }
      </Swiper>
      {/* <div className="view-all-process-goals">
        View All Process Goals
        <div className="view-all-circle">
          <span className="view-all-arrow next">
            <IonIcon src={arrowForwardOutline} />
          </span>
        </div>
      </div> */}
    </>
  );
}
